import React, { Component } from 'react';
import './related-report.css';

class RelatedReport extends Component {
    render() {
        return (
            <div class="row">
                <h5 class="stif">RELATED REPORTS</h5>
                <div class="cate_reports mar-0">
                    <h5 className="rel_rpt_h5">No related reports available.</h5>
                </div>
            </div>
        );
    }


}


export default RelatedReport;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/related-report/related-report.js